<template>
  <SAIPageWrapper>
    <SAITitle text-align="left"> Check with your employer </SAITitle>
    <div class="q-pa-md q-pb-md">
      <p>
        Speed up the order process, get approval from your employer now. Once
        your application has been approved, we will email you with the next
        steps.
      </p>
    </div>
    <div>
      <div class="q-py-sm">
        <p class="text-weight-medium text-body1 full-width q-pt-md q-pb-sm">
          Employer details
        </p>
        <QCard bordered flat>
          <QCardSection class="column">
            <span>{{ companyName }}</span>
          </QCardSection>
        </QCard>
      </div>
    </div>
    <div class="q-py-lg justify-center row">
      <SAIBtn
        :disable="disable"
        :loading="loading"
        padding="12px xl"
        label="Email My Employer"
        no-caps
        @click="$emit('click:sendHrApproval')"
      />
    </div>
    <div class="justify-center row">
      <SAIBtn
        :disable="disable"
        flat
        dense
        no-caps
        color="primary"
        label="Do it later"
        @click="$emit('to:credit-check')"
      />
    </div>
  </SAIPageWrapper>
</template>

<script>
import { SAITitle, SAIBtn, SAIPageWrapper } from 'ecx.saigon.ui.common';
import { QCard, QCardSection } from 'quasar';

export default {
  name: 'HrApprovalPage',
  props: {
    disable: Boolean,
    loading: Boolean,
    companyName: String
  },
  components: {
    SAITitle,
    SAIBtn,
    QCard,
    QCardSection,
    SAIPageWrapper
  }
};
</script>
